import { MatTableDataSource } from "@angular/material/table";

export interface DashboardData {
    Attributes: Attribute;
    UniversityList: University[];

}
export interface DashboardDataForCollege {
    CollegeList: College[]
}
export interface DashboardDataForCourse {
    CourseList: Course[]
}
export interface Attribute {
    UniversityCount: number,
    CollegeCount: number,
    CourseCount: number,
    VacancyCount: number
}

export interface University {
    UniversityId: number;
    UniversityCode: string;
    UniversityName: string;
    StateName: string;
    DistrictName: string;
    CollegeCount: number;
    CourseCount: number;
    TotalSeatCount: number;
    UniversityApprovalPending: number;
    ActiveFlag: number;
    SelfAffiliatedUniversity: number;
    EligibilityRuleCompleted: number;
    SuccessfulTest: number;
    UnResolvedFailureCount: number;
    NodalSubmissionPending: number;
    CollegeyApprovalPending: number;

    TotalAdmittedSeatCount?: number;
    TotalAllottedSeatCount?: number;
    TotalApplicationCount?: number;
    TotalVacantCount?: number;
    AvgApplicationPreference?: number;
}

export interface College {
    CollegeId: number;
    CollegeCode: string;
    CollegeName: string;
    StateName: string;
    DistrictName: string;
    TotalSeatCount: number;
    CourseCount: number;
    SuccessfulTest: number;
    UnResolvedTestCount: number;
    CollegeyApprovalPending: number;
    UniversityApprovalPending: number;
    EligibilityRuleCompleted: number;
    NodalSubmissionPending: number;
}

export interface Course {
    CollegeCourseId: number;
    CourseCode: string;
    CourseName: string;
    CourseType: string;
    TotalSeatCount: number;
    CollegeApprovalPending: string;
    TestSuccessCount: number;
    UnresolvedFailureCount: number;
    UniversityApprovalPending: string;
    EligibilityRuleCompleted: number;
    NodalSubmissionPending: number;
}

export class TabData {
    TabIndex: number;
    HeaderData: any;
    University: UniversityTable;
    College: CollegeTable;
    Course: CourseTable;

    constructor(tabIndex: number) {
        this.TabIndex = tabIndex;
        this.HeaderData = null;
        this.University = new UniversityTable();
        this.College = new CollegeTable();
        this.Course = new CourseTable();
    }
}

export class UniversityTable {
    resultFoundForUniversity: boolean;
    displayedColumnsForUniversity: string[];
    dataSourceForUniversity: MatTableDataSource<University>;
    dataCountForUniversity: number;
    dataRowsForUniversity: number;
    universityOpenState: boolean;
}

export class CollegeTable {
    resultFoundForCollege: boolean;
    displayedColumnsForCollege: string[];
    dataSourceForCollege: MatTableDataSource<College>;
    dataCountForCollege: number;
    dataRowsForCollege: number;
    collegeOpenState: boolean;
}

export class CourseTable {
    resultFoundForCourse: boolean;
    displayedColumnsForCourse: string[];
    dataSourceForCourse: MatTableDataSource<Course>;
    dataCountForCourse: number;
    dataRowsForCourse: number;
    courseOpenState: boolean;
}
